import t_15_2499 from './KZ.T.15.2499.svg'
import t_15_2499_b from './KZ.T.15.2499 black.svg'

export default [
  t_15_2499,
  t_15_2499_b
]
